import appConfigCoverGoDev from "./appConfigCoverGoDev.js"
import { COVERGO_SAAS_DEV } from "../consts.js"

export const coverHealthPenTest = {
	"coverhealth-pentest-studio.quote.hk": { appConfig: appConfigCoverGoDev, envConfig: COVERGO_SAAS_DEV }
}
